import React, { useState } from 'react';
import { Button } from '@mui/material';
import { ITechnician } from '../../../utils/entities/interface';
import { capitalizeWords, formatDate } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { ListTable } from '../../molecules/ListTable';

export const ACD_helperlist = ({
  technicians,
  isLoading,
  onUpdate,
  headerCells,
}: {
  technicians: ITechnician[];
  headerCells: [string, number][];
  isLoading: boolean;
  onUpdate: () => void;
}) => {
  const navigate = useNavigate();

  const handleOpenModal = () => {
    console.log('---------->');
  };

  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      onClick: (technician: ITechnician) =>
        navigate(`/technicians/${technician._id}`),
    },
  ];

  return (
    <>
      <ListTable
        headerCells={headerCells}
        rows={technicians}
        isLoading={isLoading}
        actions={actions}
        renderCell={(technician: ITechnician, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return capitalizeWords(technician.name) || 'N/A';
            case 1:
              return '+91-' + technician.phoneNumber.slice(0, 10);
            case 2:
              return formatDate(technician.dob) || 'N/A';
            case 3:
              return technician.type || 'N/A';
            case 4:
              return technician.experience || 'N/A';
            case 5:
              return capitalizeWords(technician.position);
            case 6:
              return (
                <Button
                  variant="outlined"
                  size="small"
                  color={technician.isPaired ? 'success' : 'warning'}
                  onClick={() => {
                    handleOpenModal();
                  }}
                  sx={{
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    borderRadius: '8px',
                  }}
                >
                  {technician.isPaired ? 'Paired' : 'Pair'}
                </Button>
              );
            default:
              return null;
          }
        }}
      />
    </>
  );
};
